var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.3915 83H4.60817C4.182 82.9987 3.77368 82.8288 3.47236 82.5274C3.17105 82.226 3.00123 81.8177 3 81.3915V4.60817C3.00132 4.182 3.17122 3.77368 3.4726 3.47236C3.77397 3.17105 4.18234 3.00123 4.6085 3H81.3918C81.818 3.00132 82.2263 3.17122 82.5276 3.4726C82.829 3.77397 82.9988 4.18234 83 4.6085V81.3918C82.9987 81.818 82.8288 82.2263 82.5274 82.5276C82.226 82.829 81.8177 82.9988 81.3915 83V83Z",
    stroke: "#EDC127",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9379 41.7138H31.9046V23.3805H45.9379C48.3691 23.3805 50.7006 24.3463 52.4197 26.0653C54.1388 27.7844 55.1046 30.116 55.1046 32.5472C55.1046 34.9783 54.1388 37.3099 52.4197 39.029C50.7006 40.7481 48.3691 41.7138 45.9379 41.7138Z",
    stroke: "#EDC127",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.938 60.0473H31.9046V41.714H45.938C48.3691 41.714 50.7007 42.6798 52.4198 44.3988C54.1389 46.1179 55.1046 48.4495 55.1046 50.8807C55.1046 52.0844 54.8675 53.2764 54.4069 54.3886C53.9462 55.5007 53.271 56.5113 52.4198 57.3625C51.5686 58.2137 50.558 58.8889 49.4459 59.3495C48.3337 59.8102 47.1417 60.0473 45.938 60.0473V60.0473Z",
    stroke: "#EDC127",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a1fa1eec3d79acb05cd7e631d1211517.svg";
export { ForwardRef as ReactComponent };